// Created by jarongallo at 3/31/21
import React, { useEffect, useState } from 'react';
import UIHover from '../../../../../components/UI/UIHover/UIHover';
import { PlusIcon } from '../../../../../assets/icons';
import Promo from '../../../../../components/UI/UIPromo/UIPromo';
import Queries from '../../../../../utils/API/Queries';
import UIModal from '../../../../../components/UI/UIModal';
import CreatePromoModal from '../../../../../components/modals/CreatePromoModal';
import { useApolloClient, useLazyQuery } from '@apollo/react-hooks';
import { toast } from 'react-toastify';
import { GET_AGENT_PROMOS } from './queries';

export default function IndividualAgentPromotions({ agentId }: IndividualAgentPromotionsProps) {
	const [showCreatePromoOverlay, setShowCreatePromoOverlay] = useState<boolean>(false);
	const [promotions, setPromotions] = useState<PromoType[]>();
	const [inviteCode] = useState();

	const client = useApolloClient();

	const [getPromotions, { data: promotionsData }] = useLazyQuery(GET_AGENT_PROMOS, {
		variables: { user: agentId, limit: 1000, isActive: true }
	});

	useEffect(() => {
		(async () => {
			await getPromotions();
		})();
	}, []);

	useEffect(() => {
		if (promotionsData) {
			setPromotions(promotionsData['promos']);
		}
	}, [promotionsData]);

	const deleteAgentPromo = async (promo) => {
		const response = await client
			.mutate({
				mutation: Queries.DELETE_PROMO,
				variables: { promoId: promo.id }
			})
			.catch((error) => toast.error('Error removing promo! ' + error.message));
		const { deletePromo } = response['data'];
		if (deletePromo) {
			await getPromotions();
			toast.success('Successfully deleted promo!');
		}
	};
	const renderCreatePromoModal = () => {
		const hideModal = () => setShowCreatePromoOverlay(false);
		const onCreatePromo = async () => {
			await getPromotions();
			hideModal();
		};
		return (
			<UIModal condition={showCreatePromoOverlay}>
				<CreatePromoModal userId={agentId} hideModal={hideModal} inviteCode={inviteCode} onFinish={onCreatePromo} />
			</UIModal>
		);
	};
	return (
		<div className='agentPage'>
			<div className='individualAgent__card--blocked-heading'>
				<p className='page-title'>Promotions</p>
				<UIHover text={'create a promotion'}>
					<img
						style={{
							width: 28,
							height: 28,
							backgroundColor: 'var(--mint-primary)',
							borderRadius: '50%',
							padding: 4,
							marginLeft: 12,
							cursor: 'pointer'
						}}
						src={PlusIcon.white}
						alt={'add'}
						onClick={() => setShowCreatePromoOverlay(true)}
					/>
				</UIHover>
			</div>
			<div className='pl-separator' />
			<div className='promo-container'>
				{promotions &&
					(promotions.filter((promo) => promo.uses < promo.maxUses).length > 0 ? (
						promotions
							.filter((promo) => promo.uses < promo.maxUses)
							.map((promo) => {
								return <Promo key={promo.id} promo={promo} removePromo={deleteAgentPromo} />;
							})
					) : (
						<p className='noActive'>There are no active agent promotions...</p>
					))}
			</div>
			{renderCreatePromoModal()}
		</div>
	);
}
